import React, { useState } from "react";
import EditOrAddShift from "../EditOrAddShiftModal/EditOrAddShift";

const JobShiftInfo = () => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">Shifts(will update soon)</p>
        </div>
        <div className="cursor-pointer">
          <img
            src="/images/editicon.svg"
            alt=""
            onClick={() => onOpenModal()}
          />
          <EditOrAddShift openModal={openModal} onCloseModal={onCloseModal} />
        </div>
      </div>
      <div className="flex justify-between employee-info-card">
        <table className="border-0">
          <tbody>
            <tr>
              <td className="title">Shift Name </td>
              <td className="data">completed </td>
            </tr>
            <tr>
              <td className="title">Effective Date </td>
              <td className="data">Jhon Cameron</td>
            </tr>
            <tr>
              <td className="title">Standard working hours/day</td>
              <td className="data">Jhon Cameron </td>
            </tr>
            <tr>
              <td className="title">Schedule type </td>
              <td className="data">27 Apr 2022 </td>
            </tr>
            <tr>
              <td className="title">Total working hours/week </td>
              <td className="data">27 Apr 2022 </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex gap-3">
        <div>
          <p>Daily working hours</p>
        </div>
        <div>
          <ul className="text-[#1F2937]">
            <li>Monday</li>
            <li>Tuesday</li>
            <li>Wednesday</li>
            <li>Thursday</li>
            <li>Friday</li>
            <li>Sat</li>
            <li>Sun</li>
          </ul>
        </div>
        <div>
          <ul className="text-[#1F2937]">
            <li>8h 00m</li>
            <li>8h 00m</li>
            <li>8h 00m</li>
            <li>8h 00m</li>
            <li>8h 00m</li>
            <li>(non-working-day)</li>
            <li>(non-working-day)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default JobShiftInfo;
